import { http } from "../../../common/http";

export const getIndustryList = () => {
    return http({
        method: 'GET',
        url: '/industry'
    });
}

export const getIndustry = (id: number) => {
    return http({
        method: 'GET',
        url: `/industry/${id}`
    });
}